import * as React from "react"
import { batch } from "@preact/signals-react";
import { Skeleton } from "@mui/material";

import { TitleWithPopover, AppTableSeeker } from "@components";
import {BACKEND_APIS} from "@constants";
import {useToast} from "@hooks";
import { isLoadingCommonFilters } from "@signals";

import { useAnalyticsDetailsData } from "./@hooks";
import { retailerColumn, firstExtractionColumn, lastExtractionColumn, countMappedColumn, countRawColumn, percentageMapping  } from "./columns";


export default function AnalyticsDetailsTable() {

	const { showToast } = useToast()
    const { tableData } = useAnalyticsDetailsData()

	if (isLoadingCommonFilters.value) return <Skeleton variant="rectangular" height={500} />
	if (!tableData.length) return <></>
	
	return <AppTableSeeker
		data={tableData}
		title={<TitleWithPopover title="User Scope Details" />}
		columns={[
			...retailerColumn(),
			firstExtractionColumn(),
			lastExtractionColumn(),
			countRawColumn(),
			countMappedColumn(),
			percentageMapping(),
		]}
	/>
}